<div class="wrapper">
  <div class="content">
    <div class="container">
      <h3>{{ state.titleText | translate: { LENGTH: pinBox?.length } }}</h3>
      <section>
        <h6>{{ 'PinPage.enterPin' | translate }}</h6>
        <div class="display-pin">
          <span
            class="box"
            [style.width]="'calc(100vw/' + pinBox?.length * 1.5 + ')'"
            [style.height]="'calc(100vw/' + pinBox?.length * 1.5 + ')'"
            [ngClass]="{ filled: slot <= pin?.length }"
            *ngFor="let slot of pinBox"
          ></span>
        </div>
      </section>
      <section>
        <ion-text color="danger" innerHtml="{{ 'PinPage.' + errorMessage | translate: { RETRIES: authFlow.retryCount } }}"></ion-text>
      </section>
    </div>
    <div class="container pinbox">
      <section>
        <ion-grid>
          <ion-row>
            <ion-col *ngFor="let n of [1, 2, 3]">
              <ion-button fill="clear" (click)="append(n)" [disabled]="disableInput">{{ n }}</ion-button>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col *ngFor="let n of [4, 5, 6]">
              <ion-button fill="clear" (click)="append(n)" [disabled]="disableInput">{{ n }}</ion-button>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col *ngFor="let n of [7, 8, 9]">
              <ion-button fill="clear" (click)="append(n)" [disabled]="disableInput">{{ n }}</ion-button>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col class="hide-in-landscape">
              <!-- 
                TODO: enable this button when we implement native device security
                <ion-button fill="clear" class="action" *ngIf="authFlow.flowType === 'login' && vault.hasNativeLock">
                <ng-lottie height="40px" [options]="{ path: '/assets/animations/native.json' }" (click)="authFlow.validate()"></ng-lottie>
              </ion-button> -->
            </ion-col>
            <ion-col>
              <ion-button fill="clear" (click)="append(0)" [disabled]="disableInput">0</ion-button>
            </ion-col>
            <ion-col>
              <ion-button fill="clear" class="action" (click)="delete()" [disabled]="disableDelete">
                <img src="assets/icon/clear.svg" slot="icon-only" />
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </section>
      <section *ngIf="state.showForgotPin">
        <ion-button fill="clear" (click)="forgotPin()" [disabled]="disableForgotPin">{{ 'PinPage.forgotPin' | translate }}</ion-button>
      </section>
    </div>
  </div>
</div>
